<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("modificadores")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div v-if="listModificadores.length>0 && respuesta" class="col-md-8 text-right">
                            <label> </label><br>
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </div>
            </div>

            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else>
                <div class="col-md-12" v-if="respuesta">
                    <div class="card">

                        <div class="row">
                            <div class="col-md-4" v-if="retail">
                                <div class="form-group">
                                    <router-link :to="{name:'modificador', params:{'idBusiness':this.idBusiness}}">
                                        <!-- <button class="btn btn-primary" v-if="!businessCentral" ><i class="fa fa-plus-square"></i>
                                            {{$t("agregarModificador")}}
                                        </button> -->
                                        <button class="btn btn-primary" ><i class="fa fa-plus-square"></i>
                                            {{$t("agregarModificador")}}
                                        </button>
                                    </router-link>
                                </div>
                            </div>

                            <div class="col-md-4 text-right" v-if="retail">
                                <el-select class="select-default filterTag"
                                        size="large"
                                        v-model="filter"
                                        filterable
                                        @change="cambioFiltro()"
                                        :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="filter in filterTag"
                                            class="select-primary"
                                            :value="filter.id"
                                            :label="filter.name"
                                            :key="filter.id">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="col-md-4 text-right" v-if="retail">
                                <div class="input-group">
                                    <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                        v-model="searchQuery"
                                        @keyup.enter.prevent="searchModificadores">
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" v-if="retail" type="button" @click="searchModificadores"><i
                                                class="fa fa-search"></i>
                                        </button>
                                        <button class="btn btn-secondary" v-if="retail" type="button" @click="removeSearch"><i
                                                class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="isSearch">
                            <div class="col-md-12">
                                <p>
                                    <small>{{showResult}}</small>
                                </p>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="listModificadores.length > 0 && retail">
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("nombreModificador")}}</th>
                                    <th>{{$t("grupo")}}</th>
                                    <th>{{$t("variacion")}}</th>
                                    <th>{{$t("acciones")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="modificador in listModificadores">
                                    <td>
                                        <div>
                                            {{modificador.name}}
                                            <span style="color: red" v-if="modificador.baja=='1'">
                                                [{{$t("BAJA")}}]
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="modificador.grupo">{{modificador.grupo}}</div>
                                        <div v-else>{{$t("todos")}}</div>
                                    </td>
                                    <td align="right">
                                        <div>{{modificador.variation | currency}}</div>
                                    </td>

                                    <td style="width: 70px; text-align: center">
                                        <router-link
                                                :to="{name:'modificador', params:{'idBusiness':idBusiness,'idModificador':modificador.id, 'pag':pag}}">
                                            <a class="btn btn-danger btn-link btn-xs">
                                                <i v-tooltip.top-center="$i18n.t('editar')" class="fa fa-pencil-alt"
                                                style="color: orange"></i>
                                            </a>
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="alert alert-danger" role="alert" v-else>
                            {{$t("noHayModificadoresEnEsteNegocio")}}
                        </div>
                        <div class="row" v-if="!isSearch && totalPags > 1">
                            <div class="col-md-12">
                                <nav>
                                    <ul class="pagination flex-wrap">
                                        <li class="page-item" :class="{'disabled':pag == 1}">
                                            <router-link class="page-link"
                                                        :to="{name: 'modificadores', params: {pag: pag-1}}"
                                                        v-if="pag != 1">&laquo;
                                            </router-link>
                                            <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                        </li>
                                        <li class="page-item" v-for="n in totalPags" :class="{active : n == pag}">
                                            <router-link class="page-link" :to="{name: 'modificadores', params: {pag:n}}">
                                                {{n}}
                                            </router-link>
                                        </li>
                                        <li class="page-item" :class="{'disabled':pag == totalPags}">
                                            <router-link class="page-link"
                                                        :to="{name: 'modificadores', params: {pag: nextPag}}"
                                                        v-if="pag != totalPags">
                                                &raquo;
                                            </router-link>
                                            <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import { mapState } from 'vuex'


    export default {
        created() {
// this.loading = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("modificadores"));
            this.getBusiness();
                    this.tieneBusinessCentral();


            this.loadingGeneral = Loading.service({text: this.$t('cargando')});

            if (this.$store.getters.idBusiness) {
                this.idBusiness = this.$store.getters.idBusiness;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {

                loadingGeneral: null,

                loading: false,
                listBusinesses: [],
                listModificadores: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
                idBusiness: this.$route.params.idBusiness,
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,
                filter: 0,
                filterTag: [],

                respuesta: true,
                retail: true,

                //BUSINESS CENTRAL
                businessCentral: false,
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getModificadores();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getModificadores();
                }
            }
        },
        computed: {
            showResult() {
                if (this.listModificadores.length == 0) {
                    return this.$t('noEncontramosResultadosPara') + this.searchQuery;
                } else {
                    const result = this.listModificadores.length == 1 ? this.$t('resultado') : this.$t('resultados');
                    return this.$t('mostrando')+" " + this.listModificadores.length + " " + result;
                }
            },
            nextPag() {
                let nextPag = parseInt(this.pag) + 1;
                return nextPag;
            },
            urlExportPDF() {

                return "../api/public/index.php/modifiers/exportListModifiers/PDF?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {

                /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
                 */
                return "../api/public/index.php/modifiers/exportListModifiers/Excel?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
            },
            ...mapState(["permiso"])
        },
        methods: {
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if (response.data.response) {

                            if (!vm.idBusiness) {
                                vm.idBusiness = response.data.result[0].id;
                            }

                            vm.listBusinesses = response.data.result;
                            vm.getModificadores();
                            vm.getCategory();
                            vm.getConfigTpvRetail();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getConfigTpvRetail() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 84,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {

                    if (response.data.response) {

                        vm.retail = false;
                         swal({
                          title: "Negocio tipo RETAIL",
                          text: "Esta información no esta disponible para su modelo de negocio",
                          confirmButtonClass: "btn btn-info btn-fill",
                          type: "info",
                          });
                    }else{
                      vm.retail = true;
                    }
                    })
                    .catch(function(error) {
                    console.log(error);
                    });
             },
            cambioFiltro() {


                this.pag = 1;
                this.totalPags = 0;
                this.getModificadores();

            },
            getCategory() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'categories/getCategoryGeneralesByProducts', config)
                    .then(function (response) {
                        if (response.data.response) {

                            if (response.data.result.length === 0) {

                                let category = {
                                    name: vm.$t('todos'),
                                    id: 0
                                };

                                vm.filterTag.push(category);
                            }

                            for (let i = 0; i < response.data.result.length; i++) {

                                if (i === 0) {

                                    let category = {
                                        name: vm.$t('todos'),
                                        id: 0
                                    };

                                    vm.filterTag.push(category);

                                }

                                let categoryname = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                };

                                vm.filterTag.push(categoryname)
                            }

                        } else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            cambioNegocio() {

                this.pag = 1;
                this.totalPags = 0;
                this.filterTag = [];

                this.getCategory();
                this.getModificadores();
                this.getConfigTpvRetail();


            },
            getModificadores() {

                const controller = this.searchQuery ? 'searchModifiersByName/' + this.searchQuery : 'getModifiersByBusiness';
                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        filter: this.filter,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "modifiers/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listModificadores = response.data.result.modifiers;
                            vm.pag = response.data.result.pag;
                            vm.totalPags = response.data.result.totalPags;

                            vm.respuesta = true;
                            vm.loadingGeneral.close();
                        } else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }
//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            searchModificadores() {
                if (this.searchQuery !== undefined && this.searchQuery !== "") {
                    this.$router.push({name: 'search-modificadores', params: {query: this.searchQuery}});
                    this.isSearch = true;
                }
            },
            removeSearch() {
                if (this.searchQuery && this.searchQuery !== "") {
                    this.searchQuery = "";
                    this.isSearch = false;
                    this.$router.push({name: 'modificadores'});
                    this.getModificadores()
                }
            },

            tieneBusinessCentral() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(
                    this.$store.getters.apiUrl + "general/getRestrictionsByUser",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {

                            switch (response.data.result[i].idRestriction) {
                                case "76":
                                    vm.businessCentral = true;
                                    break;
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        }

    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Modificadores/Modificadores.vue